import qs from 'qs';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

import { client } from '../client';
import { IGMMessage } from './types/IGMMessage';
import { Meta } from './types/Meta';

export interface IListConversationMessages {
  nodes: IGMMessage[];
  meta: Meta;
}

export interface IListConversationMessagesParams {
  limit?: number;
  cursor_direction?: 'next' | 'previous';
  cursor?: string;
  search?: string;
}

export const listConversationMessages = async (
  conversationSid: string,
  params?: IListConversationMessagesParams,
  userRole?: string,
): Promise<IListConversationMessages> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const query = qs.stringify(params, { skipNulls: true });
  if (prefix) {
    const { data } = await client.get<IListConversationMessages>(`${prefix}/conversations/${conversationSid}/messages?${query}`);
    return data;
  }
  try {
    const { data } = await client.get<IListConversationMessages>(`/conversations/${conversationSid}/messages?${query}`);
    return data;
  } catch (error: any) {
    if ((!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.get<IListConversationMessages>(
        `${collectorPrefix}/conversations/${conversationSid}/messages?${query}`,
      );
      return data;
    }
    throw error;
  }
};
